import { TChatMessage } from '~/features/chatbot/models'
import { isTextChatMessage } from '~/features/chatbot/utils'

export function formatMessages(
  messages: TChatMessage[],
  agentName?: string,
): string {
  return messages
    .filter(isTextChatMessage)
    .map((message) => {
      let speakerLabel: string = message.speaker
      if (message.speaker === 'user') {
        speakerLabel = 'Customer'
      } else if (message.speaker === 'assistant') {
        speakerLabel = agentName ?? 'Assistant'
      }
      return `${speakerLabel}: ${message.message}`
    })
    .join('\n')
}

export function findCustomerEmail(messages: TChatMessage[]): string | null {
  const emailRegex = /\S+@\S+\.\S+/
  const userMessageWithEmail = messages.find(
    (message) =>
      isTextChatMessage(message) &&
      message.speaker === 'user' &&
      emailRegex.test(message.message),
  )
  if (userMessageWithEmail && isTextChatMessage(userMessageWithEmail)) {
    const match = userMessageWithEmail.message.match(emailRegex)
    if (match) {
      return match[0]
    }
  }
  return null
}
